import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './promotional-banner-item.component.scss';
var PromotionalBannerItem = /** @class */ (function (_super) {
    tslib_1.__extends(PromotionalBannerItem, _super);
    function PromotionalBannerItem(element) {
        return _super.call(this, element) || this;
    }
    PromotionalBannerItem.prototype.init = function () { };
    PromotionalBannerItem.prototype.bindEvents = function () { };
    return PromotionalBannerItem;
}(Base));
export { PromotionalBannerItem };



//////////////////
// WEBPACK FOOTER
// ./components/promotional-banner-item/promotional-banner-item.component.ts
// module id = 471
// module chunks = 0